export enum LayoutActionTypes {
  STORE_AUTOCOLLAPSE = 'STORE_AUTOCOLLAPSE',
  TOGGLE_SIDE_HELP = 'TOGGLE_SIDE_HELP',
  TOGGLE_SIDE_CHANGELOG = 'TOGGLE_SIDE_CHANGELOG',
  SWTICH_RELEASE_NOTIFICATION = 'SWTICH_RELEASE_NOTIFICATION'
}

export interface StoreLayoutAction {
  type: LayoutActionTypes
  payload: boolean
}

export interface ToggleSideHelpAction {
  type: LayoutActionTypes
}

export interface ToggleSideChangelogAction {
  type: LayoutActionTypes
}

export interface SwitchReleaseNotification {
  type: LayoutActionTypes
  payload: boolean
}

export const storeLayoutAction = (autoCollapse: boolean): StoreLayoutAction => {
  return { type: LayoutActionTypes.STORE_AUTOCOLLAPSE, payload: autoCollapse }
}

export const toggleSideHelpAction = (): ToggleSideHelpAction => {
  return { type: LayoutActionTypes.TOGGLE_SIDE_HELP }
}

export const toggleSideChangelogAction = (): ToggleSideChangelogAction => {
  return { type: LayoutActionTypes.TOGGLE_SIDE_CHANGELOG }
}

export const switchReleaseNotificationAction = (value: boolean): SwitchReleaseNotification => {
  return { type: LayoutActionTypes.SWTICH_RELEASE_NOTIFICATION, payload: value }
}
